<template>
  <!--
  class="ec-cont"
  -->
  <div >
    <div class="overflow-hidden" align="center" >
      <!-- VIEW LOADING -->
        <v-row v-if="loading" align="center" justify="center" class="overflow-hidden" style="overflow: hidden;">
          <v-progress-linear
            v-if="layout.content"
            indeterminate
            color="primary"
          />
          <v-progress-circular
            v-else
            indeterminate
            color="primary"
            class="mt-5 qmkey-progress-circular"
          />
        </v-row>
    </div>
    <ChartsLayout
      :key="force_render"
      :chartview="(this.view_props.charts || {})"
      v-if="!!layout.content"
    />
    
  </div>
</template>
  
<style lang="scss">
  @import "@/sass/variables.scss";
  
  .ec-cont {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    min-height: 300px;
    overflow-y: hidden;
    gap: 20px;
    padding: 10px 5px 10px 5px;
  }
</style>
  
<script>
  import ChartsLayout from '@/components/charts/ChartsLayout';
  import ChartsAPI from '@/api/ChartsAPI';
  
  export default {
    name: 'ExplorerCharts',
  
    components: {
      ChartsLayout
    },
  
    props: {
      filters: {required: true},
      loading: {default: false},
      view_props: {default: () => ({})},
    },
  
    data: (() => ({
      chartview: {
        charts: {},
        layout: {},
      },
      force_render: true,
    })),
  
    mounted() {
      //this.query();
      //this.$emit('clear_units');
      this.view_props.charts = null;
      this.$nextTick(()=> {
        this.$emit('update');
      })
      
    },

    destroyed() {
      this.$emit('update');
    },
  
    computed: {
      layout() {
        return (this.view_props.charts || {}).layout || {};
      },
    },
  
    methods: {
    },

    watch: {
      layout() {
        this.force_render = !this.force_render;
      },
    }
  };

</script>
  